import { useCallback, useRef } from 'react'

import { type NormalizedInputNumberHandle } from '../../components/elements/NormalizedInputNumber'

export function useNumericValidation() {
  const mapRef = useRef<Map<string, NormalizedInputNumberHandle>>(new Map())

  const setNumericRef = useCallback(
    (name: string) => (el: NormalizedInputNumberHandle | null) => {
      if (el) {
        mapRef.current.set(name, el)
      } else {
        mapRef.current.delete(name)
      }
    },
    []
  )

  const validateAllNumericInputs = useCallback(() => {
    for (const [, handle] of mapRef.current) {
      if (handle?.validate() === false) {
        handle.focus?.()
        return false
      }
    }
    return true
  }, [])

  return {
    setNumericRef,
    validateAllNumericInputs
  }
}
